module.exports = __webpack_public_path__ + "img/blockchain.28504fc8.svg";